export default [
	{
		type: "underline",
		color: "#ffd400",
		sortIndex: "00001|00000229",
		pageLabel: "",
		position: {
			type: "FragmentSelector",
			conformsTo: "http://www.idpf.org/epub/linking/cfi/epub-cfi.html",
			value: "epubcfi(/6/4!/4/2[imprint]/6,/1:0,/1:21)"
		},
		text: "This particular ebook",
		comment: "",
		tags: [],
		id: "W3T3CGCU",
		dateCreated: "2023-06-23T18:49:09.857Z",
		dateModified: "2023-06-23T18:50:30.466Z",
		authorName: "John",
		isAuthorNameAuthoritative: true
	},
	{
		type: "underline",
		color: "#5fb236",
		sortIndex: "00001|00000245",
		pageLabel: "",
		position: {
			type: "FragmentSelector",
			conformsTo: "http://www.idpf.org/epub/linking/cfi/epub-cfi.html",
			value: "epubcfi(/6/4!/4/2[imprint]/6,/1:16,/1:49)"
		},
		text: "ebook is based on a transcription",
		comment: "",
		tags: [],
		id: "HFLH2D8Q",
		dateCreated: "2023-06-23T18:49:35.939Z",
		dateModified: "2023-06-23T18:50:30.466Z",
		authorName: "John",
		isAuthorNameAuthoritative: true
	},
	{
		type: "highlight",
		color: "#a28ae5",
		sortIndex: "00003|00000027",
		pageLabel: "",
		position: {
			type: "FragmentSelector",
			conformsTo: "http://www.idpf.org/epub/linking/cfi/epub-cfi.html",
			value: "epubcfi(/6/8!/4/2[etymology]/2,/2/1:0,/4/1:58)"
		},
		text: "Etymology\n\t\t\t\t(Supplied by a Late Consumptive Usher to a Grammar School)",
		comment: "useful information",
		tags: [],
		id: "TX8S2BZM",
		dateCreated: "2023-02-21T19:35:47.798Z",
		dateModified: "2023-06-23T18:50:30.466Z",
		authorName: "John",
		isAuthorNameAuthoritative: true
	},
	{
		type: "highlight",
		color: "#5fb236",
		sortIndex: "00006|00000049",
		pageLabel: "",
		position: {
			type: "FragmentSelector",
			conformsTo: "http://www.idpf.org/epub/linking/cfi/epub-cfi.html",
			value: "epubcfi(/6/14!/4/2[chapter-1]/4,/1:0,/1:16)"
		},
		text: "Call me Ishmael.",
		comment: "",
		tags: [],
		id: "PARGMWMZ",
		dateCreated: "2023-02-21T19:36:03.145Z",
		dateModified: "2023-06-23T18:50:30.466Z",
		authorName: "John",
		isAuthorNameAuthoritative: true
	},
	{
		type: "note",
		color: "#ffd400",
		sortIndex: "00045|00002155",
		pageLabel: "",
		position: {
			type: "FragmentSelector",
			conformsTo: "http://www.idpf.org/epub/linking/cfi/epub-cfi.html",
			value: "epubcfi(/6/92!/4/2[chapter-40]/40,/1:0,/1:201)"
		},
		comment: "What does this mean?",
		tags: [],
		id: "GTPE6G89",
		dateCreated: "2023-04-19T15:38:44.556Z",
		dateModified: "2023-06-23T18:50:30.466Z",
		authorName: "John",
		isAuthorNameAuthoritative: true
	},
	{
		type: "highlight",
		color: "#ffd400",
		sortIndex: "00050|00011246",
		pageLabel: "",
		position: {
			type: "FragmentSelector",
			conformsTo: "http://www.idpf.org/epub/linking/cfi/epub-cfi.html",
			value: "epubcfi(/6/102!/4/2[chapter-45],/32/1:0,/34/1:544)"
		},
		text: "“By the thirteenth of May our ship was ready to sail, and the next day we were out in the open sea, on our way to Ochotsh. The weather was very clear and fine, but so intolerably cold that we were obliged to keep on our fur clothing. For some days we had very little wind; it was not till the nineteenth that a brisk gale from the northwest sprang up. An uncommon large whale, the body of which was larger than the ship itself, lay almost at the surface of the water, but was not perceived by anyone on board till the moment when the ship, which was in full sail, was almost upon him, so that it was impossible to prevent its striking against him. We were thus placed in the most imminent danger, as this gigantic creature, setting up its back, raised the ship three feet at least out of the water. The masts reeled, and the sails fell altogether, while we who were below all sprang instantly upon the deck, concluding that we had struck upon some rock; instead of this we saw the monster sailing off with the utmost gravity and solemnity. Captain D’Wolf applied immediately to the pumps to examine whether or not the vessel had received any damage from the shock, but we found that very happily it had escaped entirely uninjured.”\n\t\t\tNow, the Captain D’Wolf here alluded to as commanding the ship in question, is a New Englander, who, after a long life of unusual adventures as a sea-captain, this day resides in the village of Dorchester near Boston. I have the honor of being a nephew of his. I have particularly questioned him concerning this passage in Langsdorff. He substantiates every word. The ship, however, was by no means a large one: a Russian craft built on the Siberian coast, and purchased by my uncle after bartering away the vessel in which he sailed from home.",
		comment: "",
		tags: [],
		id: "4JKDWLSF",
		dateCreated: "2023-02-21T19:36:34.563Z",
		dateModified: "2023-06-23T18:50:30.466Z",
		authorName: "John",
		isAuthorNameAuthoritative: true
	},
	{
		type: "highlight",
		color: "#ff6666",
		sortIndex: "00140|00006394",
		pageLabel: "",
		position: {
			type: "FragmentSelector",
			conformsTo: "http://www.idpf.org/epub/linking/cfi/epub-cfi.html",
			value: "epubcfi(/6/282!/4/2[chapter-135],/28/1:0,/30/1:11)"
		},
		text: "In due time the boats were lowered; but as standing in his shallop’s stern, Ahab just hovered upon the point of the descent, he waved to the mate﻿—who held one of the tackle-ropes on deck﻿—and bade him pause.\n\t\t\t“Starbuck!”",
		comment: "",
		tags: [],
		id: "YMJAWZXH",
		dateCreated: "2023-02-21T19:36:16.574Z",
		dateModified: "2023-06-23T18:50:30.466Z",
		authorName: "John",
		isAuthorNameAuthoritative: true
	},
	{
		type: "highlight",
		color: "#f19837",
		sortIndex: "00142|00000045",
		pageLabel: "",
		position: {
			type: "FragmentSelector",
			conformsTo: "http://www.idpf.org/epub/linking/cfi/epub-cfi.html",
			value: "epubcfi(/6/286!/4/2[endnotes]/4/2[note-1]/2,/1:0,/1:56)"
		},
		text: "See subsequent chapters for something more on this head.",
		comment: "Endnotes with links",
		tags: [],
		id: "YUTUT8H3",
		dateCreated: "2023-02-21T19:36:44.833Z",
		dateModified: "2023-06-23T18:50:30.466Z",
		authorName: "John",
		isAuthorNameAuthoritative: true
	},
	{
		type: "underline",
		color: "#e56eee",
		sortIndex: "00142|00002229",
		pageLabel: "",
		position: {
			type: "FragmentSelector",
			conformsTo: "http://www.idpf.org/epub/linking/cfi/epub-cfi.html",
			value: "epubcfi(/6/286!/4/2[endnotes]/4/10[note-5]/2,/1:0,/1:42)"
		},
		text: "I remember the first albatross I ever saw.",
		comment: "Don't we all",
		tags: [],
		id: "WJDX68BQ",
		dateCreated: "2023-06-23T18:50:00.799Z",
		dateModified: "2023-06-23T18:50:30.466Z",
		authorName: "John",
		isAuthorNameAuthoritative: true
	}
];
